export default __webpack_public_path__ + "static/media/lee.e162a2d6.png";